import React from 'react'
import Image from "../../asserts/images/e.png" ;
import './Direction.css'


function Direction() {
  return (
    <div className='contentimagesDirection'>
    <div className="carteEnseignant">
            <div className='imgcardEnseignant'>
                <img src={Image}></img>
            </div>
            <div className='descr'> 
                <p>Directeur: <br/> Halim Sghaier</p>
                <p id='email1'><i class="fa-regular fa-envelope"></i> directeur@admin.com</p>
            </div>
        </div>
        
        <div className="carteEnseignant">
            <div className='imgcardEnseignant'>
                <img src={Image}></img>
            </div>
            <div className='descr'> 
                <p>Secretaire général : <br/>Karim Sayeb</p>
                <p id='email2'><i class="fa-regular fa-envelope"></i> Karim.sayeb@isimm.u-monastir.tn</p>
            </div>
        </div>
    </div>
 
      )
}

export default Direction